import { createBrowserRouter, RouteObject } from "react-router-dom";
import { privateRoutes } from "./routes/privateRoutes";
import { NotFoundPage, LoadingScreen } from "@shared/components";
import { UserContextProvider } from "@shared/contexts";
import { RouteErrorBoundary } from "./error-boundary";
import { rootLoader } from "./loaders";
import { AuthRedirect, TenantSelectionPage } from "@modules/auth";

const allRoutes: RouteObject[] = [
  {
    path: "/login",
    element: <AuthRedirect />,
    errorElement: <RouteErrorBoundary />,
    HydrateFallback: LoadingScreen,
  },
  {
    path: "/tenant-selection",
    element: <TenantSelectionPage />,
    errorElement: <RouteErrorBoundary />,
    HydrateFallback: LoadingScreen,
  },
  {
    path: "/",
    loader: rootLoader,
    HydrateFallback: LoadingScreen,
    element: <UserContextProvider />,
    errorElement: <RouteErrorBoundary />,
    children: [...privateRoutes],
  },
  {
    path: "*",
    element: <NotFoundPage />,
  },
];

export const router = createBrowserRouter(allRoutes);
